import React from 'react';

const BasicStyleSVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      className={className}
      onClick={onClick}
      {...props}
    >
      <rect width='40' height='40' rx='6' fill='white' />
      <path
        d='M0 6C0 2.68629 2.68629 0 6 0H34C37.3137 0 40 2.68629 40 6V16H0V6Z'
        fill='#0957D0'
      />
    </svg>
  );
};

export default BasicStyleSVG;
